import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el kit después de comprar?',
  a: 'Al completar el pago recibís acceso inmediato por email con todos los materiales organizados por etapas. En menos de 5 minutos tenés todo.'
}, {
  q: '¿Sirve si nunca vendí nada digital antes?',
  a: 'Sí. El kit está diseñado específicamente para personas que arrancan desde cero. Cada etapa está explicada paso a paso sin asumir conocimientos previos.'
}, {
  q: '¿Necesito conocimientos técnicos previos?',
  a: 'No. Shopify, Pixel y Meta Ads están explicados desde la primera pantalla, en orden lógico. Si sabés usar Instagram, podés hacer esto.'
}, {
  q: '¿Los 3 bonos están incluidos en la oferta?',
  a: 'Sí. Los 3 bonos estratégicos están incluidos sin costo adicional en esta única oferta.'
}, {
  q: '¿Sirve si estoy en el interior del país?',
  a: 'Sí. Todo es 100% digital y funciona desde cualquier ciudad de Argentina.'
}, {
  q: '¿Cuánto tiempo necesito por día para ejecutarlo?',
  a: 'Con 1 a 2 horas por día durante un fin de semana podés tener tu ecosistema técnico completo listo.'
}, {
  q: '¿Qué diferencia tiene con tutoriales de YouTube?',
  a: 'Los tutoriales de YouTube son información suelta sin orden ni sistema. Esto es un kit ejecutable con orden lógico, criterio y metodología probada.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días completos. Si no es lo que esperabas te devolvemos el 100% sin preguntas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 md:py-20 bg-dark-900" data-id="element-56">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-57">
        <div className="text-center mb-8 md:mb-12" data-id="element-58">
          <h2 className="text-3xl md:text-5xl font-display text-white uppercase tracking-wide" data-id="element-59">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-2.5 md:space-y-3" data-id="element-60">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-dark-800 border rounded-xl overflow-hidden transition-colors ${isOpen ? 'border-gold-500/40' : 'border-white/5'}`} data-id="element-61">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full flex items-center justify-between p-4 md:p-5 text-left focus:outline-none gap-3" data-id="element-62">
                  <span className="font-bold text-white text-sm md:text-base" data-id="element-63">
                    {faq.q}
                  </span>
                  <ChevronDownIcon size={18} className={`text-gold-500 shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-64" />
                </button>

                <AnimatePresence data-id="element-65">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} data-id="element-66">
                      <div className="px-4 md:px-5 pb-4 md:pb-5 text-gray-400 leading-relaxed text-sm" data-id="element-67">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}